import { formatUrlValue } from "@/helpers/jobs";
import React from "react";

type JobSkillsProps = {
  reqdSkillsArray: skillsType[];
};

const JobSkills: React.FC<JobSkillsProps> = ({ reqdSkillsArray }) => {
  return reqdSkillsArray.length ? (
    <div
      className="border-surface-tertiary flex flex-col gap-4 border-t border-solid p-4 md:!p-6"
      id="skillSectionNew"
    >
      <h2 className="text-content-primary text-base font-bold leading-6 md:!text-lg md:!leading-[26px]">
        Skills Required
      </h2>

      <div className="flex flex-wrap">
        {reqdSkillsArray.map((skill, index) =>
          typeof skill !== "string" ? (
            <a
              key={index}
              className="bg-surface-secondary mb-[10px] mr-[10px] flex h-8 items-center gap-1 rounded-[20px] px-4 py-3 md:!h-10"
              href={`/search/${formatUrlValue(skill.skill)}-jobs`}
            >
              <span className="text-xs font-normal leading-4">
                {skill.skill}
              </span>
            </a>
          ) : null,
        )}
      </div>
    </div>
  ) : null;
};

export default JobSkills;
